jQuery(window).on('load', function () {
    var segments = location.pathname.split("/");

    var initialize = function () {
        if ((isInArray('properties', segments) || isInArray('evaluations', segments)) && isInArray('overview', segments)) {
            initializeEvents();
            showMultipleSuites();
            showDimensions();
        }
    };

    var initializeEvents = function () {
        $('#has-suite-parcel').change(function () {
            var multipleDiv = $('#multiple-suite-parcels-div');
            if ($(this).is(":checked")) {
                multipleDiv.removeClass('hide');
            } else {
                multipleDiv.addClass('hide');
            }
        });

        $(document).on('click', 'a.add-additional-suite-parcel', function () {
            var suiteParcelRow = $('.suite-parcel-row');
            var row = suiteParcelRow.last().clone();
            row.find('input.suites-parcels:not(.hidden-field)').val('');
            row.find('select.suites-parcels:not(.hidden-field) option:selected').prop("selected", false);
            row.find('select.suites-parcels:not(.hidden-field) option:first').prop("selected", "selected");
            suiteParcelRow.last().after(row);
            suiteParcelRow.last().after($('<br><br>'));
            $('select.suites-parcels').material_select();
        });

        $(document).on('click', '.delete-additional-suite-parcel', function () {
            var suiteParcelRow = $('.suite-parcel-row');
            if (suiteParcelRow.length === 1) {
                suiteParcelRow.find('input.suites-parcels:not(.hidden-field)').val('');
                suiteParcelRow.find('select.suites-parcels:not(.hidden-field) option:selected').prop("selected", false);
                suiteParcelRow.find('select.suites-parcels:not(.hidden-field) option:first').prop("selected", "selected");
            } else {
                $(this).closest('.suite-parcel-row').remove();
            }
        });
    };

    var showMultipleSuites = function () {
        var type = $('select[name="listing[listing_type]"]');
        var container = $('#has-suite-parcel').parent('p');
        var suites = $('#multiple-suite-parcels-div');
        if (type.val() === 'sale') {
            container.hide();
            suites.hide();
        }

        $(type).on('change', function () {
            if (type.val() === 'sale') {
                container.hide();
                suites.hide();
            } else {
                container.show();
                suites.show();
            }
        });
    };

    var showDimensions = function () {

        var dimensions = $('[name="suites_parcels[index][dimension]"]');

        updateDimensions(dimensions);

        $('#specifications').on('change', '[name="zonings[index][zone]"]', function () {
            updateDimensions(dimensions);
        });

    };

    var updateDimensions = function(dimensions) {
        var array = returnZoningValues();
        if ($.inArray('land', array) > -1) {
            dimensions.each(function() {

                var sf = $(this).children('option[value=SF]');
                var acre = $(this).children('option[value=ACRE]');

                acre.attr('disabled', false);

                // If there is only a single property type, then disable SF
                if (array.length === 1) {
                    sf.attr('disabled', true);
                    acre.attr('selected', true);
                } else {
                    sf.attr('disabled', false);
                }

                $(this).material_select();
            });

        } else {
            dimensions.each(function() {

                var sf = $(this).children('option[value=SF]');
                var acre = $(this).children('option[value=ACRE]');

                sf.attr('disabled', false);
                acre.attr('disabled', true);

                if (array.length === 1) {
                    sf.attr('selected', true);
                }
                $(this).material_select();
            });
        }
    };

    var returnZoningValues = function () {

        var array = [];

        $('[name="zonings[index][zone]"]').each(function () {
            array.push($(this).val());
        });

        return array;
    };


    initialize();
});